// extracted by mini-css-extract-plugin
export default {"badge":"vacationArchive_badge__fFrOJ","btnsGroup":"vacationArchive_btnsGroup__qf77r"};